// extracted by mini-css-extract-plugin
export default {"primaryBlue":"#00a2d2","primaryLightGrey":"#d1d1d1"};